import { render } from "./EditCreate.vue?vue&type=template&id=81cd30cc&ts=true"
import script from "./EditCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditCreate.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Plots/Irrigations/EditCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81cd30cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81cd30cc', __exports__)) {
    console.log('reload')
    api.reload('81cd30cc', __exports__)
  }
  
  module.hot.accept("./EditCreate.vue?vue&type=template&id=81cd30cc&ts=true", () => {
    console.log('re-render')
    api.rerender('81cd30cc', render)
  })

}


export default __exports__